(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xsto-product-trust-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('xsto-product-trust-share')) {
      class XstoProductTrustShare extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';
          const copyButton = this.querySelector('[data-xsto-copy-link]');
          if (copyButton) copyButton.addEventListener('click', () => this.copyCurrentUrl());
        }

        async copyCurrentUrl() {
          const url = window.location.href;
          let copied = false;
          try {
            if (navigator.clipboard && window.isSecureContext) {
              await navigator.clipboard.writeText(url);
              copied = true;
            }
          } catch (error) {
            copied = false;
          }
          if (!copied) {
            const textarea = document.createElement('textarea');
            textarea.value = url;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            try {
              copied = document.execCommand('copy');
            } catch (error) {
              copied = false;
            }
            textarea.remove();
          }
          const status = this.querySelector('[data-xsto-copy-status]');
          if (!status) return;
          status.textContent = copied ? 'コピーしました' : 'コピーできませんでした';
          clearTimeout(this.statusTimer);
          this.statusTimer = window.setTimeout(() => { status.textContent = ''; }, 2000);
        }
      }
      customElements.define('xsto-product-trust-share', XstoProductTrustShare);
    }
  } catch(e) { console.error(e); }
})();

})();
